import React from "react";
import { Box, IconButton, Paper, useTheme } from "@mui/material";
import { QuickStartTerm, QuickStartTermSelector } from "./QuickStartTermSelector";
import { useTranslation } from "react-i18next";
import { DeleteForever } from "@mui/icons-material";

export interface QuickStartTermSelectorsProps {
  terms?: QuickStartTerm[];
  onTermsChange: (terms?: QuickStartTerm[]) => void;
}

export function QuickStartTermSelectors(props: QuickStartTermSelectorsProps): JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();

  const { terms, onTermsChange } = props;

  return (
    <Box>
      {terms && terms.map((term, index) => (
        <Paper key={index} sx={{
          verticalAlign: "middle",
          display: "inline-block",
          m: 0, mr: 1, p:0.2, pl: 1.5, mb:2,
          fontSize: "1.1em",
          border: "2px solid",
          borderColor: term.isEntity ? theme.colors.info.main : theme.colors.success.main
          }}>
          {!term.isEntity && <>{i18n.t("text")}: <strong>{term.label}</strong></>}
          {term.isEntity && term.label}
          <IconButton
            color="error"
            size="large"
            sx={{m:0, ml: 0.5, opacity: 0.3, "&:hover": {opacity: 1}}}
            onClick={() => {
              const newTerms = [...terms];
              newTerms.splice(index, 1);
              onTermsChange(newTerms);
            }}
            >
            <DeleteForever/>
          </IconButton>
        </Paper>
      ))}
      <QuickStartTermSelector
        onTermChange={(newTerm) => {
          // if we have a new term, add it to the list
          if (newTerm) {
            const newTerms = [...(terms || []), newTerm];
            onTermsChange(newTerms);
          }
        }}
        onDeleteTerm={() => {
          // Delete the last item in the list
          if (terms && terms.length > 0) {
            const newTerms = [...terms];
            newTerms.pop();
            onTermsChange(newTerms);
          }
        }}
      />
    </Box>
  );
}
